'use strict';

exports.__esModule = true;

var _isObject = require('lodash/isObject');

var _isObject2 = _interopRequireDefault(_isObject);

var _governesses = require('../governesses');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isGoverness = function isGoverness(obj) {
  return (0, _isObject2.default)(obj) && obj instanceof _governesses.HeadGoverness;
};

exports.default = isGoverness;


//////////////////
// WEBPACK FOOTER
// ./~/kindergarten/lib/utils/isGoverness.js
// module id = YD6W
// module chunks = 0